import { render, staticRenderFns } from "./upload-payments.vue?vue&type=template&id=27d00c7e&"
import script from "./upload-payments.vue?vue&type=script&lang=js&"
export * from "./upload-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d00c7e')) {
      api.createRecord('27d00c7e', component.options)
    } else {
      api.reload('27d00c7e', component.options)
    }
    module.hot.accept("./upload-payments.vue?vue&type=template&id=27d00c7e&", function () {
      api.rerender('27d00c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/payment/upload-payments.vue"
export default component.exports